import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../../services/translation.service';
import { ConfigService } from '../../services/config.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
	getCaption(){
		let translated = this.translator.tr('CONFIG_UI_SIMULATOR_CAPTION');
		if(translated=='CONFIG_UI_SIMULATOR_CAPTION'){
			return '';
		}else{
			return translated;
		}
	}
  constructor(private translator:TranslationService,private config: ConfigService) { }
  getLogo(){
    return this.config.simulatorConfig.getLogo();
  }
  ngOnInit() {
  }

}
